import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface AirportEditorViewProps {
	airportRequest: DropdownRequest<PlaceSummary>;
	value: number | null;
	mode: ControlMode;
	onChanged: (number: number | null) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class AirportEditorView extends React.Component<AirportEditorViewProps, {}> {
	constructor(props: Readonly<AirportEditorViewProps>) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Airport';
		}

		return (
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				model={this.props.value}
				required={this.props.required}
				disabled={this.props.mode == 'display'}
				onChanged={(item) => {
					this.props.onChanged(item != null ? item.id : null)
				}}
				request={this.props.airportRequest}
				keyField="id"
				textField="displayName"
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/airports/parts/airport-editor.view.tsx